import React, { memo } from 'react';
import { Link } from '@reach/router';
import { Typography } from '@material-ui/core';
import * as Styled from './styled';

const Breadcrumbs = ({ items }) => (
  <Styled.Wrapper separator=">" aria-label="breadcrumb">
    {items.map((breadcrumb, index) => (
      <Typography
        variant="caption"
        color="primary"
        component={Link}
        to={breadcrumb.to}
        key={`breadcrumb${index}`}
      >
        {breadcrumb.text.toUpperCase()}
      </Typography>
    ))}
  </Styled.Wrapper>
);

export default memo(Breadcrumbs);